import React, { Fragment } from "react";
import { OmIcon } from "@om/component-library-react";

const WarningMessage = ({ message }) => (
  <Fragment>
    <OmIcon slot="row-2-icon" iconName="error_outline" />
    <div className="info-icon">{message}</div>
  </Fragment>
);

export default WarningMessage;
